export default __webpack_public_path__ + "static/media/news-image-fallback.90058ceb.svg";